import measureText from './measure-text';

export default measureText;
export { measureText };
